import React, { useLayoutEffect } from "react"
import { motion } from "framer-motion"
import { CombinedRoutes } from "../Common/Routes"
import { Route, Switch, Redirect } from 'react-router'
import { useDispatch } from "react-redux"
import { setPageTitle, setSideBar } from "../Store/Theme/actions"
import { withRouter } from "react-router-dom"
import TopBar from "../Components/TopBar"
import SideBar from "../Components/SideBar"

const getUrlElem = (url) => {
    const urlSplit = url.split('/')
    const route = CombinedRoutes
        .filter((item) => item.link !== null && item.link.split('/').length === urlSplit.length)
        .find((item) => item.link.split('/').every((segment, index) => segment[0] === ':' || segment === urlSplit[index]))

    const urlParams = {}
    route?.link?.split('/').forEach((segment, index) => {
        if (segment[0] === ':') urlParams[segment.slice(1)] = urlSplit[index]
    })

    const { component: Elem = null, title = null, ItemIcon: icon = null, saveData = false, multiWindow = true } = route || {}
    return { Elem, title, icon, saveData, multiWindow, urlParams }
}

const HomeRoot = ({ history }) => {
    const dispatch = useDispatch()

    useLayoutEffect(() => {
        const path = getUrlElem(history.location.pathname)
        if (path) dispatch(setPageTitle(path.title))
        dispatch(setSideBar(false))
    }, [dispatch, history.location]) // eslint-disable-line

    return (
        <motion.div className="flex min-h-screen w-full bg-pColor">
            <SideBar />
            <div className="flex min-w-0 flex-1 flex-col">
                <TopBar />
                <div className="min-w-0 p-5 text-left text-tpColor md:p-8">
                    <Switch>
                        <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
                        {CombinedRoutes.map((route) => (
                            <Route key={route.link} path={route.link} exact component={route.component} />
                        ))}
                    </Switch>
                </div>
            </div>
        </motion.div>
    )
}

export default withRouter(HomeRoot)
